export const APP_VERSION = import.meta.env.VITE_APP_VERSION?.trim() || "1.0.0903b";
